import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted } from "vue";
import Header from "@/views/Header/Header.vue";
import { initRem } from "@/utils/rem";
import { visitorPingApi, visitorSessionApi } from "@/api/other";

// 定义接口
interface ApiResponse {
  code: number;
  data: string;
  message?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let pingInterval: NodeJS.Timer | null = null;

// 初始化访客会话
const initVisitorSession = async () => {
  try {
    const res = (await visitorSessionApi()) as ApiResponse;
    if (res.code === 200 && res.data) {
      localStorage.setItem("sessionId", res.data);
      startPingInterval();
    }
  } catch (error) {
    console.error("Failed to init visitor session:", error);
  }
};

// 开始ping间隔
const startPingInterval = () => {
  pingInterval = setInterval(async () => {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      try {
        await visitorPingApi(sessionId);
      } catch (error) {
        console.error("Failed to ping:", error);
      }
    }
  }, 5000);
};

// 初始化访客统计
const initVisitorTracking = async () => {
  const sessionId = localStorage.getItem("sessionId");
  if (!sessionId) {
    await initVisitorSession();
  } else {
    startPingInterval();
  }
};

onMounted(() => {
  // 初始化rem
  initRem();

  // 初始化访客统计
  initVisitorTracking();

  console.log("window.location.protocol--", window.location.protocol);
  if (window.location.protocol !== "https:") {
    window.location.href = "https://lostbeasts.net/";
  }
});

// 清理定时器
onUnmounted(() => {
  if (pingInterval) {
    clearInterval(pingInterval);
    pingInterval = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(_component_router_view)
  ], 64))
}
}

})